<app-dialog [size]="DialogSize.SMALL">
  <app-dialog-header>Attachments</app-dialog-header>

  @if (loadErrorMessage()) {
    <div class="alert alert--error" role="alert" dataSelector="view-attachments-load-error">
      <p class="body-300">{{ loadErrorMessage() }}</p>
    </div>
  } @else if (isLoading()) {
    <div class="view-attachments-loading" dataSelector="view-attachments-loading">
      <mat-spinner [diameter]="40" />
    </div>
  } @else if (attachments().length === 0) {
    <p class="body-300 ta--center" dataSelector="view-attachments-empty">This email has no attachments.</p>
  } @else {
    <ul class="view-attachments-list" dataSelector="view-attachments-list">
      @for (attachment of attachments(); track attachment.fileId) {
        <li class="view-attachments-item">
          <span class="view-attachments-filename truncate">{{ attachment.filename }}</span>
          <button
            type="button"
            andButton
            color="ghost-secondary"
            size="small"
            tooltip="Download attachment"
            dataSelector="view-attachments-download-button"
            [attr.aria-label]="'Download ' + attachment.filename"
            [disabled]="downloadingFileId() !== null"
            (click)="downloadAttachment(attachment)"
          >
            @if (downloadingFileId() === attachment.fileId) {
              <mat-spinner [diameter]="16" />
            } @else {
              <anduin-icon name="download" fill="none" stroke="currentColor" />
            }
          </button>
        </li>
      }
    </ul>
    @if (downloadErrorMessage()) {
      <div class="alert alert--error mt-2" role="alert" dataSelector="view-attachments-download-error">
        <p class="body-300">{{ downloadErrorMessage() }}</p>
      </div>
    }
  }

  <app-dialog-footer customCancelLabel="Close" />
</app-dialog>
